import { createAction } from '@reduxjs/toolkit';

export const CREATE_AGENT_LOG_ACTION_TYPE = 'saga/createAgentLog';
export const createAgentLogAction = createAction(CREATE_AGENT_LOG_ACTION_TYPE);
